<script setup>
import BrandButton from "@/Components/Brand/BrandButton.vue";
</script>

<template>
    <!--
        Guest-only account CTA filling a grid slot. The gold background with
        the circular photo is a flat export; headline and button stay live.
    -->
    <article
        class="relative flex min-h-[437px] flex-col justify-end overflow-hidden rounded-brand bg-[#ffc003] p-6"
    >
        <img
            :src="asset('images/explore/promo-gift-giver.png')"
            alt=""
            aria-hidden="true"
            class="absolute inset-0 h-full w-full object-cover"
        />

        <div class="relative">
            <h3
                class="max-w-[262px] font-brand-display text-[40px] font-black italic uppercase leading-[0.95] tracking-[-0.02em] text-white [text-shadow:0_2px_12px_rgba(0,0,0,0.15)]"
            >
                The ultimate gift giver
            </h3>

            <BrandButton
                :href="route('register')"
                class="mt-6 h-[46px] w-full text-[15px] uppercase"
            >
                Create an Account
            </BrandButton>
        </div>
    </article>
</template>
